<template>
  <router-view />
  <live2d
    :style="style"
    :model="['Potion-Maker/Pio', 'school-2017-costume-yellow']"
    :direction="direction"
    :size="size"
    :height="height"
    v-if="!show_message"
    :showPanel="showPanel"
  ></live2d>
  <div class="robot-panel" v-if="show_message">
      <message-box :closePanel="closePanel"></message-box>
  </div>
</template>

<script>
import Live2d from '@/components/live2d/index.vue'
import MessageBox from '@/components/chatbot/MessageBox';
// import LiveModel from '@/components/LiveModel'

export default {
  name: 'App',
  components: {
    Live2d,
    MessageBox,
    //LiveModel
  },
  data () {
    return {
      direction: 'right',
      style: 'position: fixed; bottom: 0; right: 10px;',
      height: 200,
      size: 150,
      messages: [],
      show_message: false,
    }
  },
  methods: {
    showPanel(){
      this.show_message = true;
      document.getElementById("live2d-widget").style.display="none";
    },
    closePanel(){
      this.show_message = false;
      document.getElementById("live2d-widget").style.display="";
    }
  },
  created () {
    // tips 未使用，可自行在组件绑定此参数，注意此参数只会初始化一次
    setTimeout(function () {
      L2Dwidget.init(
      {
        "pluginRootPath":"live2d_models/",
        "pluginJsPath":"lib/",
        "pluginModelPath":"assets/",
        "tagMode":false,
        "debug":false,
        "model":{
          "jsonPath":"/live2d_models/assets/nepmaid.model.json"
        },
        name: {
          canvas: 'live2dcanvas',
          div: 'live2d-widget',
        },
        "display":{
          "position":"right",
          "width":150,
          "height":150,
          "right": "10px",
          "bottom": "0px",
        },
        "mobile":{
          "show":true
        },
        "react":{
          "opacity":0.8
        },
        "log":false
      }
    )
    }, 1000)

  }
}
</script>


<style lang="less">
/*滚动条的宽度*/
::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}

/*外层轨道。可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果*/
::-webkit-scrollbar-track {
  width: 6px;
  background-color: #001529;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
  display: none;
}

/*滚动条的设置*/
::-webkit-scrollbar-thumb {
  background-color: #cdd8e4;
  background-clip: padding-box;
  min-height: 28px;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

/*滚动条移上去的背景*/
::-webkit-scrollbar-thumb:hover {
  background-color: #c5d0db;
}

.unselectable {
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
</style>
